import React from 'react';

const Unauthorized: React.FC = () => (
  <div className="page-wrap d-flex flex-row align-items-center">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-12 text-center">
          <span className="display-1 d-block">401</span>
          <div className="mb-4 lead">Your session has ended or you are not authorized</div>
        </div>
      </div>
    </div>
  </div>
);

export default Unauthorized;
